export const REVIEWS = {
  LT: {
    SLUG: 'LT',
    LABEL: 'Отзывы Level.Travel',
  },
  TH: {
    SLUG: 'TH',
    LABEL: 'Отзывы TopHotels',
  },
};
export const REVIEWS_DEFAULT_VISIBLE = 10;
